import { render, staticRenderFns } from "./OrderListTab.vue?vue&type=template&id=ef37c954&"
import script from "./OrderListTab.vue?vue&type=script&lang=js&"
export * from "./OrderListTab.vue?vue&type=script&lang=js&"
import style0 from "./OrderListTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OrderListTab.vue"
export default component.exports